import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
    menu: [],
    permissions: [],
    email: ''
  };

const permissionsSlice = createSlice({
    name:"PERMISSIONS",
    initialState,
    reducers: {
        setPermissionsSlice: (state, action) => {
            return {
                ...state,
                permissions: action.payload.permissions,
                menu: action.payload.menu,
                email: action.payload.email
            };
        },
        clearPermissions: (state) =>  initialState
    }
})
export const { setPermissionsSlice, clearPermissions } = permissionsSlice.actions;
export const selectPermissionsSlice=(state)=>state;
export default permissionsSlice.reducer;